import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { FecalScoringDetailComponent } from './components/fecal-scoring-detail/fecal-scoring-detail.component';
import { FecalScoringOverviewComponent } from './components/fecal-scoring-overview/fecal-scoring-overview.component';
import { FecalScoringGuard } from './guards/fecal-scoring.guard';
import { FecalScoringResolver } from './resolvers/fecal-scoring.resolver';

export const FecalScoringRoutes = (): Routes => [
  {
    path: '',
    component: FecalScoringOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(FecalScoringResolver),
    },
  },
  {
    path: 'create/:locationId',
    component: FecalScoringDetailComponent,
    canActivate: mapToCanActivate([FecalScoringGuard]),
  },
  {
    path: 'edit/:id',
    component: FecalScoringDetailComponent,
    canActivate: mapToCanActivate([FecalScoringGuard]),
  },
];
